import { Schema } from "effect";
import { JsonUnknownRecord } from "../json-unknown.js";
import { HttpApiEndpoint, HttpApiError, HttpApiGroup } from "effect/http-api";

export const SourceHealthStatusSchema = Schema.Literals([
  "unknown",
  "healthy",
  "stale",
  "degraded",
  "failing",
  "paused",
]);

export const SourceHealthItemSchema = Schema.Struct({
  sourceKey: Schema.String,
  sourceLabel: Schema.String,
  status: SourceHealthStatusSchema,
  lastSuccessAt: Schema.OptionFromNullOr(Schema.String),
  lastFailureAt: Schema.OptionFromNullOr(Schema.String),
  lastErrorMessage: Schema.OptionFromNullOr(Schema.String),
  freshnessSeconds: Schema.OptionFromNullOr(Schema.Int),
  checkedAt: Schema.String,
  metadata: JsonUnknownRecord,
});

export const SourceHealthResponseSchema = Schema.Struct({
  items: Schema.Array(SourceHealthItemSchema),
  schemaVersion: Schema.String,
  requestId: Schema.String,
});

export const SourceHealthV3Group = HttpApiGroup.make("sourceHealthV3").add(
  HttpApiEndpoint.get("listSourceHealth", "/source-health", {
    success: SourceHealthResponseSchema,
    error: HttpApiError.InternalServerErrorNoContent,
  })
);
